


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, namespace } from 'vuex-class';
import { Shard } from '@/store/modules/lib';

const shardsNS = namespace('shards');

@Component
export default class ShCommonList extends Vue {

  @shardsNS.State('shards') protected shards: any;

  protected groups: any = {};

  // @Prop({ type: Object, default: {} }) protected items!: any;

  protected mounted() {

    // console.log(this.shards

    //   .reduce((obj: any, shard: Shard) => {

    //     if (!shard._company) {

    //       obj[shard._badge] = {
    //         id: shard._badge,
    //         shard,
    //         time: shard.timestamp,
    //         type: 'visitor',
    //       };

    //     }
    //     else {

    //       if (!obj[shard._company]) {

    //         obj[shard._company] = {
    //           id: shard._company,
    //           company: shard.company,
    //           shards: shard.target_type == 'company' ? [] : [shard],
    //           time: shard.timestamp,
    //           type: 'company',
    //         };

    //       }
    //       else {

    //         if (shard.target_type != 'company')
    //           obj[shard._company].shards.push(shard);

    //         if (obj[shard._company].time < shard.timestamp)
    //           obj[shard._company].time = shard.timestamp;

    //       }

    //     }

    //     return obj;

    //   }, {}));

    // Разделить по компаниям
    this.groups = this.shards

      .reduce((obj: any, shard: Shard) => {

        if (!shard._company) {

          obj[shard._badge] = {
            id: shard._badge,
            shard,
            time: shard.timestamp,
            type: 'visitor',
          };

        }
        else {

          if (!obj[shard._company]) {

            obj[shard._company] = {
              id: shard._company,
              company: shard.company,
              shards: shard.target_type == 'company' ? [] : [shard],
              time: shard.timestamp,
              type: 'company',
            };

          }
          else {

            if (shard.target_type != 'company')
              obj[shard._company].shards.push(shard);

            if (obj[shard._company].time < shard.timestamp)
              obj[shard._company].time = shard.timestamp;

          }

        }

        return obj;

      }, {});

      this.groups = Object.keys(this.groups)
        .map((id: string) => this.groups[id])
        .sort(function(a: any, b: any) {
          return a.time > b.time
            ? 1
            : (a.time < b.time)
              ? -1
              : 0;
        });

      console.log(this.groups);

  }

}

